import request from '@/utils/request'

let StoreApi = {
  toAddShop(data, errorback) {
    return request._get('/shop/store.store/add', data, errorback);
  },
  /*添加门店*/
  addShop(data, errorback) {
    return request._post('/shop/store.store/add', data, errorback);
  },

  /*门店详情*/
  shopDetail(data, errorback) {
    return request._get('/shop/store.store/edit', data, errorback);
  },

  /*门店编辑*/
  editShop(data, errorback) {
    return request._post('/shop/store.store/edit', data, errorback);
  },

  /*删除门店*/
  deleteShop(data, errorback) {
    return request._post('/shop/store.store/delete', data, errorback);
  },

  /*门店列表*/
  shoplist(data, errorback) {
    return request._post('/shop/store.store/index', data, errorback);
  },

  /*门店选择列表*/
  storeLists(data, errorback) {
    return request._post('/shop/data.store/lists', data, errorback);
  },

  /*店员列表*/
  clerklist(data, errorback) {
    return request._post('/shop/store.clerk/index', data, errorback);
  },
  /*门店选择列表*/
  toAddClerk(data, errorback) {
    return request._get('/shop/store.clerk/add', data, errorback);
  },
  /*店员添加*/
  addClerk(data, errorback) {
    return request._post('/shop/store.clerk/add', data, errorback);
  },
  /*店员详情*/
  clerkDetail(data, errorback) {
    return request._get('/shop/store.clerk/edit', data, errorback);
  },
  /*店员编辑*/
  editClerk(data, errorback) {
    return request._post('/shop/store.clerk/edit', data, errorback);
  },
  /*删除店员*/
  deleteClerk(data, errorback) {
    return request._post('/shop/store.clerk/delete', data, errorback);
  },
    /*弹出层查询*/
  search(data, errorback) {
    return request._post('/shop/store.clerk/search', data, errorback);
  },
  /*核销订单列表*/
  orderList(data, errorback) {
    return request._post('/shop/store.order/index', data, errorback);
  },
    /*banner编辑*/
  editBanner(data, errorback) {
    return request._post('/shop/plus.banner.banner/edit', data, errorback);
  },

  /*删除banner*/
  deleteBanner(data, errorback) {
    return request._post('/shop/plus.banner.banner/delete', data, errorback);
  },

  /*banner列表*/
  bannerlist(data, errorback) {
    return request._post('/shop/plus.banner.banner/index', data, errorback);
  },

  /*添加banner*/
  addBanner(data, errorback) {
    return request._post('/shop/plus.banner.banner/add', data, errorback);
  },
  /*协议列表*/
  agreement(data, errorback) {
    return request._post('/shop/plus.agreement.agreement/index', data, errorback);
  },
  /*协议编辑*/
  agreementEdit(data, errorback) {
    return request._post('/shop/plus.agreement.agreement/edit', data, errorback);
  },
  /*CDK列表*/
  cdkList(data, errorback) {
    return request._post('/shop/plus.cdk.cdk/index', data, errorback);
  },
  /*生产CDK*/
  cdkAdd(data, errorback) {
    return request._post('/shop/plus.cdk.cdk/add', data, errorback);
  },
   /*下载二维码*/
   dowErweima(data, errorback) {
    return request._post('/shop/plus.cdk.cdk/edit', data, errorback);
  },
   /*一键导出*/
   dowAllErweima(data, errorback) {
    return request._post('/shop/plus.cdk.cdk/down', data, errorback);
  },
}

export default StoreApi;



// WEBPACK FOOTER //
// ./src/api/store.js